/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 25/12/2023
 */

import React, { useContext, useEffect, useRef } from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { Navigation } from "swiper";
import { isMobile } from 'react-device-detect';
import CheckoutContext from '../../Context/CheckoutContext';
import { SET_NO_OF_PROFESSIONALS } from '../../Pages/CheckoutPage';

import styles from "./NoHrsSelect.module.css"

const NoResSelect = ({ noRes }) => {

    const { checkoutData, dispatch } = useContext(CheckoutContext);
    const resPrevRef = useRef(null);
    const resNextRef = useRef(null);

    useEffect(() => {
        noRes && dispatch({ type: SET_NO_OF_PROFESSIONALS, payload: noRes[0].noResId })
    }, [noRes])

    const onNoOfProffesionalsSelect = (val) => {
        dispatch({ type: SET_NO_OF_PROFESSIONALS, payload: val })
    }

    return (
        <div className={styles.selectionContainer}>
            <Swiper
                slidesPerView={isMobile ? 5 : 9}
                spaceBetween={10}
                slidesPerGroup={isMobile ? 5 : 9}
                freeMode={true}
                modules={[Navigation]}
                className={styles['sample-slider']}
                navigation={{
                    prevEl: resPrevRef.current,
                    nextEl: resNextRef.current,
                }}
            >
                {noRes?.map(res => (


                    <SwiperSlide
                        key={res.noResId}
                        className={styles.hrsContainer}
                    >
                        <div
                            onClick={() => onNoOfProffesionalsSelect(res.noResId)}
                            className={`${styles.numberButton} ${checkoutData.noRes == res.noResId && styles.numberButtonSelected}`}
                        >
                            {res.noRes}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <div ref={resPrevRef} className="swiper-button-prev"></div>
            <div ref={resNextRef} className="swiper-button-next"></div>
        </div>
    )
}

export default NoResSelect